import { DatePicker, Modal } from "antd";
import React, { useState } from "react";
import { FaFileDownload } from "react-icons/fa";
import { RiEqualizerFill } from "react-icons/ri";
import CarePlanTaskList from "./Task/CarePlanTasksList";
import CarePlanDailyTaskList from "./Task/CarePlanDailyTaskList";
import SetCarePlanTask from "./Task/CarePlanTasksList/setCarePlanTask";
import UpdateCarePlanDailyTask from "./Task/CarePlanDailyTaskList/updateDailyTask";
import CarePlanDailyMedication from "./Medication/CarePlanDaily";
import CarePlanMedications from "./Medication/CarePlanMedication";
import UpdateDailyMedications from "./Medication/CarePlanDaily/updateDailyMedications";
import SetDailyMedications from "./Medication/CarePlanMedication/addNewMedication";


function Careplan() {
  const [toggleState, setToggleState] = useState(1);
  const [selectedTask, setSelectedTask] = useState(null);

  const [selectedTaskRadio, setSelectedTaskRadio] = useState("Daily");
  const [selectedMedicationRadio, setSelectedMedicationRadio] =
    useState("DailyMedication");

  const taskOptions = [
    { label: "Daily Task", value: "Daily" },
    { label: "Set Task", value: "Set" },
  ];

  const medicationOptions = [
    { label: "Daily Medication", value: "DailyMedication" },
    { label: "Set Medication", value: "SetMedication" },
  ];

  const isSet =
    (toggleState === 1 && selectedTaskRadio === "Set") ||
    (toggleState === 2 && selectedMedicationRadio === "SetMedication");

  const handleRadioChange = (e) => {
    if (toggleState === 1) {
      setSelectedTaskRadio(e.target.value);
    } else {
      setSelectedMedicationRadio(e.target.value);
    }
  };
  const [isMainModalOpen, setIsMainModalOpen] = useState(false); // First Modal
  const [isTimeModalOpen, setIsTimeModalOpen] = useState(false); // Second Modal
  const [modalType, setModalType] = useState(""); // 'dailyTask' or 'setTask'
  const handleOpenModal = () => {
    if (toggleState === 1) {
      setModalType(selectedTaskRadio === "Daily" ? "dailyTask" : "setTask");
    } else {
      setModalType(
        selectedMedicationRadio === "DailyMedication"
          ? "dailyMedication"
          : "setMedication"
      );
    }
    setIsMainModalOpen(true);
  };

  const handleTaskResponse = (response) => {
    setSelectedTask(response); // save task info if needed
    setIsMainModalOpen(false); // close first modal
    setIsTimeModalOpen(true); // open second modal
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  const confirmFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  const closeFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  const renderTable = () => {
    if (toggleState === 1) {
      if (selectedTaskRadio === "Daily") {
        return (
          <CarePlanDailyTaskList />
        );
      } else {
        return (<CarePlanTaskList />);
      }
    }

    if (toggleState === 2) {
      if (selectedMedicationRadio === "DailyMedication") {
        return (
          <CarePlanDailyMedication />
        );
      } else {
        return (
          <CarePlanMedications />
        );
      }
    }
  };

  const handleModalClose = () => {
    setIsMainModalOpen(false)
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="border p-7 border-gray-300 rounded-xl">
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-4">
            {(toggleState === 1 ? taskOptions : medicationOptions).map(
              (opt) => (
                <label key={opt.value} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="tabRadio"
                    value={opt.value}
                    checked={
                      toggleState === 1
                        ? selectedTaskRadio === opt.value
                        : selectedMedicationRadio === opt.value
                    }
                    onChange={handleRadioChange}
                  />
                  <span className="text-gray-700">{opt.label}</span>
                </label>
              )
            )}
          </div>
          <div className="flex gap-2 items-center">
            <button
              className="px-4 py-1 border border-blue-600 text-blue-600 rounded hover:bg-blue-50 bg-white"
              onClick={handleOpenModal}
            >
              {isSet ? "Set" : "Update"}
            </button>

            <button
              className="px-4 py-1 flex gap-2 items-center border border-blue-600 bg-white text-blue-600 rounded hover:bg-blue-50"
              onClick={openFilterModal}
            >
              <RiEqualizerFill />
              Filter
            </button>
            <div>
              <FaFileDownload className="w-6 h-6 cursor-pointer text-brand-primaryColor" />
            </div>
          </div>
        </div>

        <div className="flex mb-5 bg-zinc-200 py-2 rounded-full">
          <div className="w-1/2 px-1">
            <button
              className={`w-full px-4 py-3 font-semibold rounded-full ${toggleState === 1
                  ? "text-white bg-cyan-700"
                  : "bg-white text-gray-700"
                }`}
              onClick={() => setToggleState(1)}
            >
              Task
            </button>
          </div>
          <div className="w-1/2 px-1">
            <button
              className={`w-full px-4 py-3 font-semibold rounded-full ${toggleState === 2
                  ? "text-white bg-cyan-700"
                  : "bg-white text-gray-700"
                }`}
              onClick={() => setToggleState(2)}
            >
              Medications
            </button>
          </div>
        </div>

        <div className="border rounded-lg text-center text-gray-600 overflow-x-auto h-[600px] overflow-y-scroll scrollWidth">
          {renderTable()}
        </div>
      </div>
      <Modal
        open={isMainModalOpen}
        onCancel={handleModalClose}
        footer={null}
        title={
          modalType === "dailyTask"
            ? "Daily Task"
            : modalType === "setTask"
              ? "Set Task"
              : modalType === "dailyMedication"
                ? "Daily Medication"
                : "Set Medication"
        }
        destroyOnClose
      >
        {modalType === "dailyTask" && (
          <UpdateCarePlanDailyTask handleClose={handleModalClose} />
        )}

        {modalType === "setTask" && (
          <SetCarePlanTask handleClose={handleModalClose} />
        )}

        {modalType === "dailyMedication" && (
          <UpdateDailyMedications handleClose={handleModalClose} />
        )}

        {modalType === "setMedication" && (
          <SetDailyMedications handleClose={handleModalClose} />
        )}
      </Modal>
      <Modal
        title="Time Spent"
        open={isTimeModalOpen}
        onCancel={() => setIsTimeModalOpen(false)}
        footer={null}
        centered
      >
        <div className="p-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Total Time Spent<span className="text-red-500"> *</span>
              </label>
              <input
                type="text"
                className="w-full border outline-none placeholder:font-medium border-gray-300 rounded-md px-3 py-2 text-sm"
                placeholder="Enter total time spent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Enter Actual Spent Minutes
                <span className="text-red-500"> *</span>
              </label>
              <input
                type="text"
                className="w-full border outline-none placeholder:font-medium border-gray-300 rounded-md px-3 py-2 text-sm"
                placeholder="Enter Actual Spent Minutes"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                rows="3"
                className="w-full border outline-none placeholder:font-medium border-gray-300 rounded-md px-3 py-2 text-sm"
                placeholder="Enter description..."
              ></textarea>
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <button
              className="px-4 py-1 border rounded border-gray-400 text-sm bg-white text-cyan-800"
              onClick={() => setIsTimeModalOpen(false)}
            >
              Cancel
            </button>
            <button className="px-4 py-1 bg-brand-primaryColor text-white rounded text-sm">
              Submit
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        title={
          <span className="text-lg font-sans font-semibold">Task Filter</span>
        }
        open={isFilterModalOpen}
        onOk={confirmFilterModal}
        onCancel={closeFilterModal}
        closable={{ "aria-label": "Custom Close Button" }}
        footer
      >
        <div>
          <div className="grid grid-cols-2 gap-3 p-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Task Name
              </label>
              <input
                type="text"
                placeholder="Enter task name"
                className="mt-1 w-full border placeholder:font-medium border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-600"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Date & Time
              </label>
              <DatePicker className="mt-1 py-2 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Entered By
              </label>
              <input
                type="text"
                placeholder="Enter name"
                className="mt-1 w-full border placeholder:font-medium border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-600"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button
              className="px-4 py-1 border rounded border-gray-400 text-sm bg-white text-cyan-800"
              onClick={() => setIsTimeModalOpen(false)}
            >
              Cancel
            </button>
            <button className="px-4 py-1 bg-brand-primaryColor text-white rounded text-sm">
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Careplan;
